/* eslint-disable max-len */
import React, { useState } from 'react'
import { Text, Pane, Flex, Button, Label, PortalOverlay, Selector, Toast } from '@leverege/ui-elements'
import { GlobalState, UI } from '@leverege/ui-redux'
import classes from './SelectLocationClasses.css'
// import { GlobalState } from '@leverege/ui-redux'
// import I18N from '@leverege/i18n'

// const { t } = I18N.ns( 'recovrGeneric.ownershipTransfer' )

const gearIcon = 'https://storage.googleapis.com/prd-generic-kudelski-ui-assets/Nav%20Icons/nav-integrations-blue.svg'

export default function OrganizationSelectionScreen( props ) {
  const { onClose, company, orgNameAndIdList } = props

  const systemId = company.systemId
  // const projectId = company.projectId
  const integrationStatusKey = `deere/company/${company.id}/integrationData`
  const [ orgId, setOrgId ] = useState( '' )
  const [ isSubmitted, setIsSubmitted ] = useState( false )
  
  const selectorRenderer = ( value, selectorLabel ) => {
    return <Text style={{ paddingLeft : '8px' }}> {selectorLabel} </Text>
  }

  const onSubmit = async ( evt ) => {
    try {
      await GlobalState.dispatch( async ( dispatch, getState, { api } ) => {
        
        await dispatch( UI.set( integrationStatusKey, null ) )
        const res = await api.interface( systemId, 'company' )
          .obj( company.id )
          .srv( 'deere' )
          .post( 'createOrgAccess', { orgId } )
        
        setIsSubmitted( true )
        const redirectEndpoint = res.redirectEndpoint
        window.location.href = redirectEndpoint
      } )

    } catch ( error ) {
      // eslint-disable-next-line no-console
      console.log( { msg : 'OrganizationSelectionScreen.onSubmit() - Error selecting organization', err : error } )
      Toast.error( 'Error selecting organization' )
      onClose( evt )
    }
  }

  const iconBackgroundStyle = { 
    height : '24px', 
    width : '24px', 
    borderRadius : '2px', 
    backgroundColor : '#F0F6FF', 
    justifyContent : 'center', 
    alignItems : 'center',
    position : 'relative' 
  }

  const renderDialog = () => (
    <Pane variant="editorDialog" className={classes.dialog}>
      <Flex className={classes.dialogHeader} justify="space-between">
        <Text
          style={{ fontWeight : 'bold' }}
          icon={(
            <Flex style={{ ...iconBackgroundStyle }}>
              <img src={gearIcon} alt="Gear Icon" />
            </Flex>
          )}>
          Select Organization for Integration
        </Text>
        
      </Flex>
      <Pane className={classes.dialogBody}>
        <Flex variant="col" justify="space-between">
          <Text variant="bodySmall">
            Select an Organization from John Deere to connect with <b>{company.name}</b>
          </Text>
          
          <Label style={{ paddingTop : '16px', size : '13px' }}> Select Organization </Label>          
          
          <Selector
            className={classes.selector}
            value={orgId}
            targetAttachment="bottom right"
            checkStyle="toggle"
            onChange={( data ) => { setOrgId( data.value ) }}
            renderer={selectorRenderer}
            popupStyle={{ maxHeight : '304px' }}
            values={orgNameAndIdList}/>
          
          <Text style={{ fontSize : '13px', color : '#67798E' }}>This action is necessary to complete the integration process</Text>
          
        </Flex>

      </Pane>
      <Flex variant="rowL" className={classes.dialogFooter} justify="flex-end">
        <Button disabled={!orgId || isSubmitted} variant="submit" onClick={onSubmit}> Next </Button>
      </Flex>
    </Pane>
  )

  return (
    <PortalOverlay position="center" show closeOnEscape={false} closeOnDocumentClick={false} >
      {renderDialog()}
    </PortalOverlay>
  )
}
